import React from 'react'
import { useIntl } from 'react-intl';
import Button from '~components/button';
import { RxCross2 } from "react-icons/rx";
import { useHistory } from 'react-router-dom';

// import './style.scss';

const TopCTABar = ({ onClose = () => {} }) => {
  const intl = useIntl();
  const history = useHistory();

  const handleMakeAccountClick = () => {
    history.push('/intake/client/full');
  };

  return (
    <div className="c-notify_bar">
      <Button className="c-noti-close" onClick={onClose}>
        <RxCross2 size={24} />
      </Button>
      <div className="c-notify__inner">
        <div className="info">
          {intl.formatMessage({
            id: 'containers.city.seo.free-service.title',
            defaultMessage: 'Free service:',
          })} {intl.formatMessage({
            id: 'containers.city.seo.free-service.sub-title',
            defaultMessage: 'Be the first to know new cleaners have registered by making an account for free',
          })}
        </div>
        <Button className="c-btn c-btn-info" onClick={handleMakeAccountClick}>{intl.formatMessage({ id: 'containers.city.seo.free-service.button', defaultMessage: 'Make Account' })}</Button>
      </div>
    </div>
  )
}

export default TopCTABar